module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/landing-stronghold.d9511697.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/landing-stronghold.jpg
// module id = 3169
// module chunks = 11